export default "__VITE_ASSET__Chi_jBrK__"